import Vue from 'vue'
import Router from 'vue-router'
import Splash from './views/Splash.vue'
import Home from './views/Home.vue'
import Docentes from './views/Docentes.vue'
import Estudiantes from './views/Estudiantes.vue'
import Presidencia from './views/Presidencia.vue'

Vue.use(Router)

var rutas = [
  {
    path: '/',
    name: 'splash',
    component: Splash
  },
  {
    path: '/inicio',
    name: 'home',
    component: Home
  },
  {
    path: '/docentes',
    name: 'docentes',
    component: Docentes
  },
  {
    path: '/estudiantes',
    name: 'estudiantes',
    component: Estudiantes
  },
  {
    path: '/presidencia',
    name: 'presidencia',
    component: Presidencia
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
  }
];


const router = new Router({  
  routes: rutas
});

// router.beforeEach((to, from, next) => {

router.beforeEach((to, from, next) => {
  // console.log(router.app);
  router.app.$globalEvent.$emit('enterSound');
  router.app.$emit('enterSound');
  next();
})

export default router;

// 
